import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/img/icon_duihao-mian.png'


const _hoisted_1 = { class: "serviceevaluation" }
const _hoisted_2 = {
  key: 0,
  class: "content1"
}
const _hoisted_3 = { class: "company" }
const _hoisted_4 = { class: "flex-n fac" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "flex-n fac right-item" }
const _hoisted_8 = { class: "flex-n fac right-item mt-20" }
const _hoisted_9 = { class: "flex-n fac right-item mt-20" }
const _hoisted_10 = {
  key: 1,
  class: "content2"
}
const _hoisted_11 = { class: "text2" }

import {onMounted, reactive, ref} from "vue";
import StarScore from "@/components/StarScore/StarScore.vue";
import {useRoute, useRouter} from "vue-router";
import weChatApi from "@/utils/Api/WeChat";
import { showConfirmDialog } from 'vant'
import CONFIG from "../../../../public/serverConfig";

export default /*@__PURE__*/_defineComponent({
  __name: 'serviceevaluation',
  setup(__props) {

const pageTitle=ref('服务评价');

const route=useRoute();
const form=ref({
  professionalismStar:'',
  serviceSuppliesStar:'',
  serviceAttitudeStar:'',
  evaluateContent:""
})
const loading=ref(false);

onMounted(()=>{
  getData();
})
const disabled=ref(true);
const getData=()=>{
  weChatApi.getServiceMerchantDetail({
    obituaryId:route.query.obituaryId,
    merchantId:route.query.companyId
  }).then(res=>{
    console.log(res)
    form.value=res.data;
    if(res.data.professionalismStar==null&&res.data.serviceAttitudeStar==null&&res.data.serviceSuppliesStar==null){
      disabled.value=false;
    }else{
      form.value.professionalismStar=Number(res.data.professionalismStar)/2;
      form.value.serviceSuppliesStar=Number(res.data.serviceSuppliesStar)/2;
      form.value.serviceAttitudeStar=Number(res.data.serviceAttitudeStar)/2;
    }

  })
}
//评价完成
const submitSuccess=ref(false);
const submit=()=>{

  showConfirmDialog({
    title: '提交确认',
    message:
        '是否确认提交该服务评价，提交后不能更改',
  })
      .then(() => {
        // on confirm
        loading.value=true;
        weChatApi.createServiceEvaluation({
          ...form.value,
          professionalismStar:form.value.professionalismStar*2,
          serviceSuppliesStar:form.value.serviceSuppliesStar*2,
          serviceAttitudeStar:form.value.serviceAttitudeStar*2,
          obituaryId:route.query.obituaryId,
          merchantId:route.query.companyId
        }).then(res=>{
          //评价成功
          submitSuccess.value=true;
        }).finally(()=>{
          loading.value=false;
        })
      })
      .catch(() => {
        // on cancel
      });

}
const router=useRouter();

const gotoPage=(path:string)=>{
  router.push(path);
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: pageTitle.value,
      "left-arrow": "",
      fixed: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (gotoPage('/')))
    }, null, 8, ["title"]),
    (!submitSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "由" + _toDisplayString(form.value.companyName) + "为您提供服务", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: form.value.merchantCover
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text" }, "专业度", -1)),
                _createVNode(_component_van_rate, {
                  modelValue: form.value.professionalismStar,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.professionalismStar) = $event)),
                  disabled: disabled.value,
                  "allow-half": "",
                  color: "#2f7dfd"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text" }, "服务用品", -1)),
                _createVNode(_component_van_rate, {
                  modelValue: form.value.serviceSuppliesStar,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.serviceSuppliesStar) = $event)),
                  disabled: disabled.value,
                  "allow-half": "",
                  color: "#2f7dfd"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text" }, "服务态度", -1)),
                _createVNode(_component_van_rate, {
                  modelValue: form.value.serviceAttitudeStar,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.serviceAttitudeStar) = $event)),
                  disabled: disabled.value,
                  "allow-half": "",
                  color: "#2f7dfd"
                }, null, 8, ["modelValue", "disabled"])
              ])
            ])
          ]),
          _createVNode(_component_van_field, {
            modelValue: form.value.evaluateContent,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.evaluateContent) = $event)),
            rows: "10",
            autosize: "",
            class: "textarea",
            type: "textarea",
            disabled: disabled.value,
            placeholder: "请写下本次服务给您的感受"
          }, null, 8, ["modelValue", "disabled"]),
          (!disabled.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "primary-btn",
                      onClick: submit
                    }, "提交评价"))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "primary-btn",
                      onClick: submit
                    }, "提交中"))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[10] || (_cache[10] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text" }, "感谢您的宝贵评价", -1)),
          _createElementVNode("button", {
            class: "colorful-btn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (gotoPage('/')))
          }, "返回首页"),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, _toDisplayString(form.value.companyName) + "殡仪服务公司", 1),
            _cache[9] || (_cache[9] = _createElementVNode("div", null, "为您提供全程服务", -1))
          ])
        ]))
  ]))
}
}

})